exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":root{--font-family-base:\"Segoe UI\",\"HelveticaNeue-Light\",sans-serif;--max-content-width:1080px;--max-container-width:100%;--screen-xs-min:480px;--screen-sm-min:768px;--screen-md-min:992px;--screen-lg-min:1200px;--border-color:#dce0e0;--background-color:#fff;--btn-color:#404040;--btn-primary-bg:#0667b3;--btn-primary-color:#fff;--btn-primary-hover-bg:#58595b;--btn-secondary-bg:#0667b2;--btn-secondary-color:#fff;--btn-secondary-hover-bg:#0667b2}.yePoj{padding-left:0;padding-right:0;overflow-x:hidden}._3jwRb{margin:0 auto;padding-bottom:24px;max-width:1080px}._1H-34{padding-top:48px}._3YFT1{color:#404040;line-height:24px;margin:0 0 24px;padding:0 15px;font-weight:700}._23E3R{font-weight:600;font-size:32px;line-height:48px;margin-bottom:50px;text-align:center;color:#222529}@media screen and (max-width:1170px){._3YFT1{text-align:center}._3jwRb{padding-left:20px;padding-right:20px}}@media screen and (max-width:767px){._1QXXA{margin:0 0 24px 34px}}._2llcv{background-color:#0e436c}._1wXxy{background-color:#f6f9fc}._3Fylf{background-color:#fff}._3WUHc{background:linear-gradient(90deg,#0667b3,#0c7fd8 149.65%)}._2PXaX{margin-top:100px}", ""]);

// exports
exports.locals = {
	"root": "yePoj",
	"container": "_3jwRb",
	"pageContainer": "_1H-34",
	"containerTitle": "_3YFT1",
	"findPlace": "_23E3R",
	"marginLeft": "_1QXXA",
	"contentBoxesBg": "_2llcv",
	"contentBoxesBg2": "_1wXxy",
	"contentBoxesWhite": "_3Fylf",
	"linearBg": "_3WUHc",
	"readyBox": "_2PXaX"
};